import posthog from 'posthog-js';
import { supabase } from '@/integrations/supabase/client';

let posthogInitialized = false;
let hasLoggedPostHogLockTimeout = false;

export const initializePostHog = async (existingSession?: { access_token: string } | null) => {
  if (posthogInitialized || typeof window === 'undefined') {
    return;
  }

  try {
    let session = existingSession;
    if (!session) {
      try {
        const { data } = await supabase.auth.getSession();
        session = data.session;
      } catch (error) {
        const message = error instanceof Error ? error.message : '';
        if (message.includes('Navigator LockManager lock')) {
          if (!hasLoggedPostHogLockTimeout) {
            console.warn('PostHog: Session lock timeout, deferring initialization');
            hasLoggedPostHogLockTimeout = true;
          }
        } else {
          console.warn('PostHog: Could not get session, deferring initialization:', error);
        }
        return;
      }
    }

    if (!session?.access_token) {
      console.log('PostHog: No authenticated session, deferring initialization');
      return;
    }

    // Get PostHog API key from Supabase secrets via authenticated edge function
    const response = await fetch('https://zbdgjhhhnlfgsxwxavcj.supabase.co/functions/v1/get-posthog-config', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
        'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpiZGdqaGhobmxmZ3N4d3hhdmNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAxOTQ4NzcsImV4cCI6MjA2NTc3MDg3N30.yfQsbm8mLqYg4X2Ku_RI0vN_qt4oI44Jo8TDsgzw0kE',
      },
    });

    if (!response.ok) {
      console.warn('Failed to get PostHog config, analytics disabled');
      return;
    }

    const { apiKey, host } = await response.json();

    if (!apiKey) {
      console.warn('PostHog API key not available');
      return;
    }

    posthog.init(apiKey, {
      api_host: host || 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      loaded: () => {
        console.log('PostHog initialized successfully');
        posthogInitialized = true;
      },
      // Privacy settings
      respect_dnt: true,
      opt_out_capturing_by_default: false,
      // Error capture settings for better stack traces
      capture_performance: true,
      autocapture: {
        dom_event_allowlist: ['click', 'change', 'submit'],
        css_selector_allowlist: ['[ph-capture]'],
      },
      // Feature flags
      bootstrap: {
        distinctID: undefined,
      },
    });

    posthogInitialized = true;
  } catch (error) {
    console.warn('Failed to initialize PostHog:', error);
  }
};

export const getPostHog = () => {
  if (!posthogInitialized || typeof window === 'undefined') {
    return null;
  }
  return posthog;
};

export const isPostHogInitialized = () => posthogInitialized;

export { posthog };
